/**
 * Archive Page Animation
 * Animate post cards on scroll with GSAP
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class ArchiveAnimation {
  constructor() {
    this.init();
  }

  init() {
    const postCards = document.querySelectorAll('.post-card');
    
    if (!postCards.length) {
      return;
    }

    postCards.forEach((card, index) => {
      gsap.to(card, {
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: 'power2.out',
        delay: index * 0.1,
        scrollTrigger: {
          trigger: card,
          start: 'top 85%',
          once: true,
        },
        onComplete: () => {
          card.classList.add('animated');
        }
      });
    });
  }
}
